import BaseApiClient from '../BaseApiClient';
import { TaskProductTypeInterface } from '@interfaces/TaskProductType.interface';

export class ApiTaskProductType extends BaseApiClient {
  /**
   * Get all items
   */
  async all(): Promise<Array<TaskProductTypeInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/task-product-type?page[size]=999')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get item
   */
  async get(id: number): Promise<TaskProductTypeInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/task-product-type/${id}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { taskProductTypeQueryKeys } from './query-keys';
export { useTaskProductTypeQuery, useTaskProductTypesQuery } from './use-task-product-type-queries';
